import { authClient } from "./auth-client";

export const sendMagicLink = async (name: string, email: string) => {
  const { data, error } = await authClient.signIn.magicLink({
    email: email,
    name: name,
  });
  if (error) {
    console.error(error);
  }
  console.log(data);
};

export const signInGoogle = async () => {
  const data = await authClient.signIn.social({
    provider: "google",
  });
  console.log(data);
};
